import { makeStyles, css } from '@conexasaude/styles'

import noise from '@/assets/noise.png'

const useStyles = makeStyles({
  container: ({ colors }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 72px);
    padding: 0 16px;
    background: linear-gradient(
      252.46deg,
      ${colors.primary[700]} 0%,
      ${colors.primary[900]} 100%
    );
    background-size: 400% 400%;
    animation: gradient 10s ease infinite;

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }

    .forgot-password {
      &__noise {
        position: absolute;
        background-image: url(${noise});
        //background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        height: calc(100vh - 72px);
        width: 100%;
      }
    }
    .tz-section {
      bottom: 40px;
      position: fixed;
      margin: 0 16px 0 16px;

      div {
        color: ${colors.neutral[300]};
      }
    }
  `,
})

export { useStyles }
